exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-pagination.is-background .el-pager li:not(.disabled).active {\n  background: linear-gradient(90deg, #4d7cff 0%, #36a9f6 100%);\n}", ""]);

// exports
